import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import TemplatePriceList from './TemplatePriceList';

import { CreateTemplateSizePrice } from './CreateTemplateSizePrice';
import { EditTemplateSizePrice } from './EditTemplateSizePrice';

export default {
      list: TemplatePriceList,
      create: CreateTemplateSizePrice,
      edit: EditTemplateSizePrice,
      icon: AttachMoneyIcon,
}